import React, { memo, useEffect, useState } from "react";
import { Box, Card, CardContent, Chip, Stack } from "@mui/material";
import { motion } from "framer-motion";
import useResponsive from "../../../../Hooks/useResponsive";
import BatchSessionDetailsModal from "./BatchSessionDetailsModal";

const BatchDetailsChip = memo(({ batchDetails }) => {
  const [direction, setDirection] = useState("row");
  const mdDown = useResponsive("down", "md");
  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);
  return (
    <Box sx={{ width: "100%" }}>
      {/* <motion.div initial={{ y: -200, x: 0, opacity: 0 }} animate={{ y: 0, x: 0, opacity: 1 }} transition={{ duration: 0.8 }}> */}
      <Card
        sx={{
        //   background: "linear-gradient(125deg, #51475bff, #792191ff)",
        backgroundColor:'#d2effe',
          color: "#fff",
          borderRadius: 1,
          width: "100%",
        }}
      >
        <CardContent sx={{ padding: "11px !important" }}>
          <Stack
            spacing={1}
            direction={direction}
            justifyContent="space-between"
            sx={{
              flexWrap: !mdDown ? "wrap" : "nowrap",
              gap: !mdDown ? 1 : 0,
            }}
          >
            <Chip
              variant="outlined"
              label={`Batch Name : ${batchDetails?.course_batch_name || "Not Available"}`}
              sx={{
                backgroundColor: "white",
                color: "#000000",
                fontWeight: 500,
                fontSize: "1rem",
                px: 2,
              }}
            />
            <Chip
              variant="outlined"
              label={`Batch No : ${batchDetails?.course_batch_id || "Not Available"}`}
              sx={{
                backgroundColor: "white",
                color: "#000000",
                fontWeight: 500,
                fontSize: "1rem",
                px: 2,
              }}
            />
            <Chip
              variant="outlined"
              label={`Syllabus : ${batchDetails?.syllabusName || "Not Available"}`}
              sx={{
                backgroundColor: "white",
                color: "#000000",
                fontWeight: 500,
                fontSize: "1rem",
                px: 2,
              }}
            />
            <Chip
              variant="outlined"
              label={`Capacity : ${batchDetails?.course_batch_capacity || "Not Available"}`}
              sx={{
                backgroundColor: "white",
                color: "#000000",
                fontWeight: 500,
                fontSize: "1rem",
                px: 2,
              }}
            />
            {/* <Chip
              variant="outlined"
              label={
                <span>
                  <BatchSessionDetailsModal seletctedSubEnrollmentId={10} batchId={batchDetails?.course_batch_id}/>
                </span>
              }
              sx={{
                backgroundColor: "white",
                color: "#000000",
                fontWeight: 500,
                fontSize: "1rem",
                // px: 2,
              }}
            /> */}
          </Stack>
        </CardContent>
      </Card>
      {/* </motion.div> */}
    </Box>
  );
});

export default BatchDetailsChip;
